/*
 * The logged-in customer's profile (/api/profile/user-info), cached in
 * localStorage under the login token. Only a real profile (with an id) is
 * cached; an error answer never is. An expired login (401) clears the cache
 * and the token, and - where the page needs a login - goes to /login.
 */
const ProfileSession = {
    cached(token) {
        try {
            const info = JSON.parse(localStorage.getItem(token) || 'null');
            return info && info.id ? info : null;
        } catch (e) {
            return null;
        }
    },
    save(token, info) {
        if (!info || !info.id) return;
        try { localStorage.setItem(token, JSON.stringify(info)); } catch (e) { /* private window */ }
    },
    expired(token, redirect) {
        try { localStorage.removeItem(token); } catch (e) { /* ignore */ }
        document.cookie = "login_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax";
        if (redirect) {
            location.href = (window.SHOP_BASE || "") + "/login";
        }
    },
    // resolves the profile, or null (not logged in any more / error)
    async userInfo(token, redirectOnExpired = false) {
        const cached = this.cached(token);
        if (cached) return cached;
        try {
            const response = await fetch("/api/profile/user-info", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({ token }),
            });
            if (response.status === 401) {
                this.expired(token, redirectOnExpired);
                return null;
            }
            const data = await response.json();
            if (!response.ok || !data || !data.data || !data.data.id) return null;
            this.save(token, data.data);
            return data.data;
        } catch (e) {
            return null;
        }
    },
};

window.ProfileSession = ProfileSession;
